import { BaseService } from "./BaseService";
import type {
  AutoExportSchedule,
  CreateAutoExportScheduleBody,
  ListAutoExportSchedulesQuery,
  PaginatedAutoExportSchedules,
  UpdateAutoExportScheduleBody,
} from "@/types/analytics-auto-export";

class AnalyticsAutoExportService extends BaseService {
  private readonly basePath = "/analytics/auto-export";

  list(
    params?: ListAutoExportSchedulesQuery,
  ): Promise<PaginatedAutoExportSchedules> {
    return this.get<PaginatedAutoExportSchedules>(this.basePath, {
      skip: 0,
      take: 20,
      ...params,
    });
  }

  getById(id: string): Promise<AutoExportSchedule> {
    return this.get<AutoExportSchedule>(`${this.basePath}/${id}`);
  }

  create(body: CreateAutoExportScheduleBody): Promise<AutoExportSchedule> {
    return this.post<AutoExportSchedule>(this.basePath, body);
  }

  update(
    id: string,
    body: UpdateAutoExportScheduleBody,
  ): Promise<AutoExportSchedule> {
    return this.patch<AutoExportSchedule>(`${this.basePath}/${id}`, body);
  }

  deleteSchedule(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }

  runNow(id: string): Promise<void> {
    return this.post<void>(`${this.basePath}/${id}/run`);
  }
}

export const analyticsAutoExportService = new AnalyticsAutoExportService();
